import React from 'react';

export const WebsiteIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="21" viewBox="0 0 25 21" {...props}>
        <path
            fill="currentColor"
            d="M3.77 2a.75.75 0 00-.77.76.77.77 0 00.77.77.75.75 0 00.77-.73v-.04A.75.75 0 003.8 2h-.03zM5.94 2a.75.75 0 00-.77.74v.02a.77.77 0 101.33-.53.75.75 0 00-.53-.23h-.03zM8.23 2a.75.75 0 00-.77.74v.02a.77.77 0 101.33-.53.75.75 0 00-.53-.23h-.03z"
        />
        <path
            fill="currentColor"
            d="M24.07 20.64H.8a.8.8 0 01-.8-.8V.8A.8.8 0 01.8 0h23.27a.8.8 0 01.8.8v19.04a.8.8 0 01-.8.8zm-22.48-1.6h21.68V1.6H1.6v17.46z"
        />
        <path
            fill="currentColor"
            d="M23.49 7H.91a.87.87 0 01-.64-.3A1.05 1.05 0 010 6c0-.27.1-.52.27-.7.17-.2.4-.3.64-.3h22.58c.24 0 .47.1.64.3a1.05 1.05 0 010 1.41c-.17.18-.4.29-.64.29z"
        />
    </svg>
);
